<template>
  <div class="d-flex justify-content-center">
    <div v-if="showLogo">
      <img src="https://unicampo.coop.br/uploads/bkp/2022/portal/logoUnicampo.png" style="
          display: block;
          margin-left: auto;
          margin-right: auto;
          width: 100%;
        " />
    </div>
    <div class="col-md-8 mt-5" v-else>
      <div class="row">
        <div class="topoVerde">
          <span class="">Seja bem vindo(a) a Cooperativa Unicampo!</span>
        </div>
      </div>
      <div class="row">
        <div class="page" style="border-radius: 0px 0px 5px 5px">
          <div class="d-flex flex-column p-3">
            <span class="mt-2 font-size-16">
              <p>Estamos felizes em saber do seu interesse em fazer parte da nossa Cooperativa!</p>

              <p>Ao realizar esse cadastro, suas informações serão armazenadas em nosso sistema, tornando o processo de
                adesão mais ágil e prático.</p>

              <p>Ressaltamos que, para concluir o processo de ingresso, é necessário atender aos critérios do Estatuto
                Social, como apresentar registro no conselho de classe profissional, integralizar as quotas-partes,
                entre outros.</p>

              <p>A filiação à Cooperativa não garante oportunidade de trabalho, mas é condição para estar apto à
                prestação de serviços via UNICAMPO.</p>

              <p>
                Para mais informações sobre o processo de filiação, entre em contato pelo
                e-mail:
                <a href="mailto:gestaodepessoas@unicampo.coop.br">
                  gestaodepessoas@unicampo.coop.br
                </a>
              </p>

              <p class="mb-0">Atenciosamente</p>
              <p class="mb-0">Equipe Unicampo</p>

              <p>
                <a href="https://wa.me/+55554440093800">
                  44 4009-3800
                </a>
              </p>
            </span>
          </div>
          <div class="mt-5 d-flex justify-content-between">
            <div class="col-8 marginDetalhes">
              <div class="detalhe1"></div>
              <div class="detalhe2"></div>
              <div class="detalhe3"></div>
            </div>
            <div class="col-4 d-flex justify-content-end align-items-center">
              <router-link to="/perfilPessoal/cadastroPessoal">
                <b-button variant="success " class="mt-1">
                  Completar Cadastro
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h1: "Home",
      showLogo: true,
      candidato: null,
      requisito: null,
      tpPessoa: null,
    };
  },

  created() {
    this.validarCooperado();
  },

  methods: {
    async validarCooperado() {
      const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
      if (isErp) {
        // Siga o fluxo de candidato, mas sem chamada à API
        this.candidato = 3;
        this.requisito = { PROGRESSO: 100 };
        this.tpPessoa = this.$store.state.me.tp_Pessoa.cd_tp_pessoa;
        this.showLogo = false;
        return;
      }
      this.$http
        .get("api/cadastroCandidato/validarCandidato")
        .then((response) => {
          this.candidato = response.data.candidato;
          this.requisito = response.data.requisito;
          this.tpPessoa = this.$store.state.me.tp_Pessoa.cd_tp_pessoa;

          if (
            (this.candidato < 3 && this.requisito.PROGRESSO == 100) ||
            this.candidato > 2
          ) {
            this.showLogo = true;
          } else if (this.tpPessoa != 1 && this.tpPessoa != 5) {
            this.showLogo = true;
          } else {
            this.showLogo = false;
          }
        })
        .catch((err) => {
          this.$tools.alerta(err, "error");
        });
    },
  },
};
</script>

<style scoped>
.detalhe1 {
  border-radius: 0px 10px 10px 0px;
  background: rgba(0, 146, 63, 0.5);
}

@media (max-width: 768px) {
  .topoVerde {
    font-size: 14px; /* Tamanho de fonte menor para dispositivos móveis */
  }
}

.marginDetalhes {
  margin-left: -12px;
}

.detalhe1 {
  width: 30%;
  height: 30px;
  flex-shrink: 0;
  border-radius: 0px 10px 10px 0px;
  background: rgba(0, 146, 63, 0.5);
}
.detalhe2 {
  width: 35%;
  height: 30px;
  flex-shrink: 0;
  border-radius: 0px 10px 10px 0px;
  background: rgba(36, 208, 110, 0.5);
}
.detalhe3 {
  width: 40%;
  height: 30px;
  flex-shrink: 0;
  border-radius: 0px 10px 10px 0px;
  background: rgba(0, 146, 63, 0.5);
}
</style>
